import React from "react"
import PropTypes from "prop-types"
import { Button, Flex } from "antd"
import styles from "./index.module.css"
import { useTranslation } from "react-i18next"

export default function ExperiencesFilterDropdown({ value = [], onChange, updateSearchFilters, categories = [] }) {
  const { t } = useTranslation()
  const handleSelect = (exp) => {
    let newValue
    if (value.includes(exp)) {
      newValue = value.filter((e) => e !== exp)
    } else {
      newValue = [...value, exp]
    }
    onChange(newValue)
    updateSearchFilters?.({ category_name: newValue.length > 0 ? newValue.join(", ") : "" })
  }

  const handleClear = () => {
    onChange([])
    updateSearchFilters?.({ category_name: "" })
  }

  return (
    <div className={styles.dropdownContent}>
      <Flex gap={8} wrap="wrap" className={styles.categoriesWrapper}>
        {categories && categories.length > 0 ? (
          categories.map((cat) => (
            <Button
              key={cat.id}
              type={value.includes(cat.name) ? "primary" : "default"}
              shape="round"
              onClick={() => handleSelect(cat.name)}
            >
              {cat.name}
            </Button>
          ))
        ) : (
          <div className={styles.noExperiencesFound}>{t("filterTags.no_experiences_found")}</div>
        )}
      </Flex>
      <Button type="link" onClick={handleClear}>
        {t("filterTags.clear")}
      </Button>
    </div>
  )
}

ExperiencesFilterDropdown.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  updateSearchFilters: PropTypes.func,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string
    })
  )
}
